import { MdKeyboardArrowLeft } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { IconButton } from '../../../components'
import {
  Breadcrumbs,
  PageContent,
  PageHeader
} from '../../../layout/components'
import { ComissionsReportForm } from './components/Form'
import { ComissionsReportProvider } from './context/comissionsReport.context'

export const ComissionsReport = () => {
  const navigation = useNavigate()
  return (
    <div>
      <PageHeader>
        <div
          style={{
            fontSize: 22,
            fontWeight: 600,
            marginBottom: '.5rem',
            height: 40,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          }}
        >
          <IconButton
            onClick={() => navigation('/reports')}
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <MdKeyboardArrowLeft
              size={24}
              color="#565656"
              style={{ background: '' }}
            />
          </IconButton>
          <div style={{ marginLeft: '1rem', fontSize: 22, fontWeight: 800 }}>
            Relatório de Comissões
          </div>
        </div>
        <Breadcrumbs
          links={[{ url: 'reports', name: 'Relatórios' }]}
          span="Relatório de Comissões"
        ></Breadcrumbs>
      </PageHeader>
      <PageContent>
        <ComissionsReportForm />
      </PageContent>
    </div>
  )
}

export const CommissionsReportPage = () => (
  <ComissionsReportProvider>
    <ComissionsReport />
  </ComissionsReportProvider>
)

export default CommissionsReportPage
